import RootState from 'store/state'

import ACWState, { IACWContact } from './acw.state'

const EMPTY_ACW: ACWState = {}

export const selectACW = (state: RootState): ACWState => state.acw ?? EMPTY_ACW

export const selectACWByID =
    (contactID?: string) =>
    (state: RootState): IACWContact | undefined =>
        contactID ? selectACW(state)[contactID] : undefined

export const selectVoiceACW = (state: RootState): IACWContact | undefined =>
    Object.values(selectACW(state)).find((c) => c.type === 'voice')
